import { ExternalLink, Target, Zap } from "lucide-react"

export function DealSnapshot({ deal }) {
  const hotLead = deal.hotLead === true
  const sourceLabel = deal.sourceLabel ?? "Rightmove"
  const scoreLabel = Number.isFinite(deal.score) ? deal.score : "Building"
  const snapshotImage = deal.primaryImage?.url ?? deal.image

  return (
    <section className="relative overflow-hidden rounded-xl border border-border bg-card p-4 text-card-foreground shadow-sm">
      <div className="flex flex-col gap-5 sm:flex-row">
        <div className="h-28 w-full shrink-0 overflow-hidden rounded-lg border border-border/50 bg-muted sm:w-40">
          <img
            src={snapshotImage}
            alt={deal.address}
            className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
          />
        </div>

        <div className="flex min-w-0 flex-1 flex-col justify-center">
          <div className="flex items-start justify-between gap-4">
            <div className="min-w-0">
              <h2 className="truncate text-2xl font-bold tracking-normal text-foreground">
                {deal.address}
              </h2>
              <div className="mt-2 flex flex-wrap items-center gap-3 text-xs font-medium text-muted-foreground">
                <span className="inline-flex items-center gap-1.5 rounded-md bg-muted px-2 py-0.5 font-medium text-foreground">
                  <ExternalLink className="h-3 w-3" />
                  {sourceLabel}
                </span>
                {hotLead ? (
                  <span className="inline-flex items-center gap-1 text-primary">
                    <Zap className="h-3 w-3" />
                    Hot Lead
                  </span>
                ) : null}
                {deal.postcodeArea ? (
                  <span className="inline-flex items-center gap-1.5 rounded-md bg-muted px-2 py-0.5 font-mono text-foreground">
                    {deal.postcodeArea}
                  </span>
                ) : null}
                <span className="inline-flex items-center gap-1.5">
                  <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground/50" />
                  Last Activity: {deal.lastActivity ?? "2 days ago"}
                </span>
              </div>
            </div>

            <div className="shrink-0">
              <span className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/10 px-3 py-1.5 text-sm font-bold text-primary">
                <Target className="h-4 w-4" />
                Score: {scoreLabel}
              </span>
            </div>
          </div>

          <div className="mt-auto flex items-center gap-2 pt-7">
            <span className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
              CURRENT STAGE:
            </span>
            <span className="rounded-md border border-border bg-background px-2.5 py-1 text-sm font-medium text-foreground">
              {deal.stage}
            </span>
          </div>
        </div>
      </div>
    </section>
  )
}
